import React from 'react';
import { CheckboxGroup, FormField, TextCheckbox } from 'taboola-ultimate-ui';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { vtaLookBackWindowValidations } from 'modules/tracking/validations/vtaLookBackWindowValidations';
import { useCampaignGroupEnabled } from '../../../campaigns/modules/campaigns-group-form/hooks/useCampaignGroupEnabled';
import { useVtaLookBackWindowValue } from './UseVtaLookBackWindowValue';
import { VtaLookbackWindowInputWithDropdown } from './VtaLookbackWindowInputWithDropdown/VtaLookbackWindowInputWithDropdown';
import { useVtaLookBackWindowField } from './useVtaLookBackWindowField';
import styles from './vtaLookBackWindowInput.module.scss';

export const VtaLookBackWindowField = () => {
    const campaignGroupExtensionEnabled = useCampaignGroupEnabled();

    const {
        lookBackFormFieldType: { value: vtaLookBackWindowType },
        lookBackFormFieldValue: { onChange: onVtaLookBackWindowChange },
    } = useVtaLookBackWindowField();

    const { value: isViewThroughWindowDisabled, onChange: setIsViewThroughWindowDisabled } = useFormFieldValue({
        field: 'isViewThroughWindowDisabled',
    });
    const lookBackMaxValue = useVtaLookBackWindowValue();
    const isVTAWindowCheckboxEnabled = useConfigMatch({
        [FEATURE_FLAGS.VTA_LOOKBACK_WINDOW_CHECKBOX_ENABLED]: 'true',
    });

    return (
        <div className={styles['body']}>
            <FormField
                inputId="vta-look-back-window"
                label={
                    <FormattedMessage
                        id="tracking.conversion.properties.vta.window.title"
                        defaultMessage="View Through Conversion Window"
                    />
                }
                description={
                    <FormattedMessage
                        id="tracking.conversion.properties.vta.window.description"
                        defaultMessage="Set the time after a view during which a conversion will be recorded.{newline}Notice: this will only apply to accounts that have checked the ‘Clicks and view-through’ attribution settings."
                    />
                }
                subtext={
                    <FormattedMessage
                        id={`tracking.conversion.properties.vta.window.subtext.${vtaLookBackWindowType}`}
                        defaultMessage="Max: {max} days"
                        values={{
                            max: lookBackMaxValue[vtaLookBackWindowType],
                        }}
                    />
                }
            >
                <VtaLookbackWindowInputWithDropdown
                    validations={vtaLookBackWindowValidations}
                    isDisabled={isViewThroughWindowDisabled}
                />
            </FormField>
            {campaignGroupExtensionEnabled && isVTAWindowCheckboxEnabled && (
                <CheckboxGroup
                    onSelectCheckbox={() => {
                        onVtaLookBackWindowChange(0);
                        setIsViewThroughWindowDisabled(true);
                    }}
                    onUnselectCheckbox={() => setIsViewThroughWindowDisabled(false)}
                    selectedValues={[isViewThroughWindowDisabled]}
                >
                    <TextCheckbox
                        value
                        title={
                            <FormattedMessage
                                id="tracking.conversion.properties.vta.window.checkbox.title"
                                defaultMessage="Don't count View Through Conversions for this campaign"
                            />
                        }
                    />
                </CheckboxGroup>
            )}
        </div>
    );
};
